import { Navigate, Outlet } from "react-router-dom";
import useAuthCheck from "../hooks/use-auth-check.ts";

// https://github.com/remix-run/react-router/issues/10637#issuecomment-1802180978
const ProtectedRoutes = () => {
    const { isAuthenticated, isFetchingAuthenticationInformations } = useAuthCheck();

    if (isFetchingAuthenticationInformations) {
        return null;
    }

    return isAuthenticated ?
        <>
            <Outlet/>
        </> : 
        <Navigate to="/sign-in"  replace />;
};

export default ProtectedRoutes;